module.exports = __webpack_public_path__ + "static/media/scalpel-path.b1997a08.svg";